interface SalesUnit {
    salesUnit: SalesUnits;
    quantity: number;
}

class SiteLabelUnit
    extends SiteLabel<Array<SalesUnit>, ISiteLabelConfig> {

    private readonly _innerModel: ISiteModel;
    private readonly _changedEvent: (data: ISiteModelValueChanged) => void;
    private readonly _sorts : SalesUnits[] = ["Piece", "Bunch", "Quantity", "Layer", "Trolley"];

    constructor(card: SiteCard, model: ISiteModel, modelData: ISiteModel, element: HTMLElement) {
        super(card, model, modelData, element);

        let container = this.query("div[data-type='unit']").first<QueryElement<HTMLElement>>();
        if (container === null)
            throw "Container not found."
        
        container.addClass("unit");

        let salesUnits: { [event: string]: number } = {};
        let value = this.getModelValue();
        value && value.forEach((value, key) => {
            salesUnits[value.salesUnit] = value.quantity;
        });

        this._innerModel = new SiteModel(salesUnits);
        let innerModelData = new SiteModel({});

        this._sorts.forEach((value, key) => {
            let name = this.getModelData()[QueryJSON.toCamelCase(value)];

            let template = QueryElement.QueryElement("label")
                .setAttr("data-path", value)
                .setAttr("data-config", JSON.stringify({ popout: "none", decimals: 0 }))
                .append(QueryElement.QueryElement("input").setAttr("type", "text"))
                .append(QueryElement.QueryElement("span").addClass("label").setHtml(name))
                .get();

            if (template === null)
                return;

            let decimalElement = new SiteLabelDecimal(card, this._innerModel, innerModelData, template);
            decimalElement.init(decimalElement.getInput());
            container && container.append(decimalElement);
        });

        this._changedEvent = this._innerModel.changedEvent.on(data =>  {
            this.setValue(this.getValue());
        });
        this.off("click", null);
    }
    getInput() {
        return null;
    }
    makeActive() {
        if (super.makeActive()) {
            this.makeNextActive();
        }
        return false;
    }
    makeInactive() {
        super.makeInactive();
    }
    defaultConfig(): ISiteLabelConfig {
        return {
            popout: "normal",
            scroll: "top"
        };
    }
    getValue() {
        let toReturn : Array<SalesUnit> = [];
        for (let sort of this._sorts) {
            let item = this._innerModel.get([sort]);

            if(item > 0)
                toReturn.push({
                    quantity: item,
                    salesUnit: sort
                });
        }
        return toReturn;
    }
    async remove(removeInner = true) {
        await super.remove(removeInner);

        this._innerModel.changedEvent.off(this._changedEvent);
    }
}